var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tab-links",attrs:{"role":"tablist"}},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,class:{
      'tab-links__item': true,
      'tab-links__item--active': _vm.activeTab === tab.id,
    },attrs:{"role":"presentation"}},[_c('router-link',{staticClass:"tab-links__link",attrs:{"to":tab.url,"id":("tab_" + index)}},[_vm._v(" "+_vm._s(tab.label)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }